// extracted by mini-css-extract-plugin
export default {"wrapper":"K2L6JFYPu3gqlspTCAuA"};